import { createFileRoute } from '@tanstack/react-router';
import { RunsListPage } from '@/pages/runs/RunsListPage';

export const Route = createFileRoute('/runs/')({
  component: RunsListPage,
});
